//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import logo from "./components/logo.vue";
import masterNav from "./components/menu/index.vue";
import navClient from "./components/menu/nav-client.vue";
import login from "./components/login.vue";
import LoginData from "./LoginData";
import MenuIcon from "./components/menu-icon.vue";

import MasterLogin from "../MasterLogin/index.vue";
import "../assets/theme/index.scss";

import { BUS, isElectron } from "../../tools/tools";

export default {
  name: "MasterMenu",
  components: {
    logo,
    login,
    masterNav,
    MasterLogin,
    MenuIcon,
    navClient,
  },
  props: {
    MGplugin: {
      default: null,
    },
    MGSensorsSdk: {
      default: null,
    },
    theme: {
      default: "light",
    },
    jump: {
      type: Function,
    },
    loginConfig: {
      type: Object,
    },
    avatarConfig: {
      type: Object,
    },
    menuConfig: {
      type: Object,
    },
    isShowMenu: {
      type: Boolean,
      default: true,
    },
    userInfo: {
      type: Object,
    },
    sensors: {
      type: Object,
    },
    homeUrl: {
      type: String,
      default: "",
    },
    beforeToHome: {
      type: Function,
    },
    action: {
      type: Object,
      default() {
        return {};
      },
    },
    isTikTokChannel: {
      type: Boolean,
      default: false,
    },
    judgeJump: {
      type: Function,
    },
    mobileRedirectUri: {
      type: Function,
    },
    showMenu: {
      type: Boolean,
      default: true,
    },
    greyToggle:{
      type: Boolean,
      default: false,
    }
  },
  provide() {
    return {
      jumpCallBack: this.jump,
      loginConfig: this.loginConfig,
      avatarConfig: this.avatarConfig,
      menuConfig: this.menuConfig,
      action: this.action,
      sensors: this.sensors,
      plugin: this.MGplugin,
      beforeToHome: this.beforeToHome,
      judgeJump: this.judgeJump,
      mobileRedirectUri: this.mobileRedirectUri
    };
  },
  data() {
    return {
      plugin: null,
      SensorsSdk: null,
      themeObj: null, // 设置主题的对象
      isclose: false, // 移动端导航打开？
      openMenuClass: "", //// 移动单菜单打开
      pluginConfig: {
        // 头像参数
        imageResource: "",
        compResource: "",
        electronWindow: "0.2.7",
        electronMac: "0.2.7",
        fontWindow: "0.1.6",
        fontMac: "0.1.6",
        productNumber: "YD00502987485782",
        businessId: "d3f0636e4e144d5fbd7c80a542596830",
        lanhuservice: "https://qyj.lanhuapp.com",
        systemUpdateTime: "",
      },
      isClient: false
    };
  },
  computed: {
    themeClassName() {
      setTimeout(() => {
        this.setLofinTheme(this.theme);
      }, 10);

      if (["light", "blue", "dark", "transparent"].includes(this.theme)) {
        return `theme-${this.theme}`;
      }

      return `theme-light`;
    },
  },
  methods: {
    init() {
      if (this.plugin) {
        this.plugin.initWeiXin(); // 初始化微信登录sdk
        this.plugin.setLoginData();
      }
    },
    setDeviceId() {
      // 设置deviceId
      if (!this.SensorsSdk) return;
      new this.SensorsSdk().getDeviceId().then((res) => {
        document.cookie = `deviceId=${res}`;
      });
    },
    setLofinTheme(theme) {
      if (theme === "dark") {
        this.themeObj?.dark();
      } else {
        this.themeObj?.light();
      }
    },
    clickMenuMobile(flag) {
      // 移动端 导航展开
      this.isclose = flag;
      if (flag) {
        document.querySelector("html").style = "overflow:hidden";
      } else {
        document.querySelector("html").style = "";
      }
      this.openMenuClass = flag ? "open" : "";
    },
    MLoginEvent() {
      BUS.on("MLogin", (options) => {
        const { type, datas } = options;
        this.$emit(type, datas);
      });
    },
    MHeadEvent() {
      BUS.on("MHead", (options) => {
        const { type, datas } = options;
        this.$emit(type, datas);
      });
    },
    setPluginConfig() {
      // 设置pluginConfig
      if (window && location) {
        const host = location.host;
        this.pluginConfig.imageResource =
          host === "mastergo.com"
            ? "https://image-resource.mastergo.com/"
            : "https://image-resource-dev.mastergo.com/";
        this.pluginConfig.compResource =
          host === "mastergo.com"
            ? "https://comp-resource.mastergo.com"
            : "https://comp-resource-dev.mastergo.com";
      }
    },
    openLogin(options) {
      // 打开登陆弹窗
      BUS.emit("openLogin", {
        openLogin: true,
        isRegister: false,
        options,
      });
    },
    openRegister(options) {
      // 打开注册弹窗
      BUS.emit("openLogin", {
        openLogin: true,
        isRegister: true,
        options,
      });
    },
    closeLogin() {
      // 关闭弹窗
      BUS.emit("openLogin", {
        openLogin: false,
        isRegister: false,
      });
    },

    userInfoInit() {
      // 初次加载判断用户是否处于登陆状态
      if (this.userInfo) {
        BUS.emit("setUserInfo", this.userInfo);
      }
    },
  },
  mounted() {
    if (this.MGplugin) {
      this.plugin = this.MGplugin;
      this.setPluginConfig();
    }
    if (this.MGSensorsSdk) {
      this.SensorsSdk = this.MGSensorsSdk;
      this.setDeviceId();
    }

    this.MHeadEvent();
    if (this.plugin && this.plugin.theme) {
      this.themeObj = this.plugin.theme;
    } else if (this.$loginTheme) {
      this.themeObj = this.$loginTheme;
    }
    this.MLoginEvent();
    this.userInfoInit();
    this.init();
    this.isClient = isElectron();
  },
};
